import React from "react"
import type { TypeI18n } from "../../../types"
import config from "../../../config"
import type { RestaurantAttendance } from "../../../store/plans/PlansReducer"
import { connect } from "react-redux"

type TypeProps = {
  i18n: TypeI18n,
  restaurantAttendance: RestaurantAttendance
}

type TypeState = {}

class RestaurantInfo extends React.PureComponent<TypeProps, TypeState> {
  render() {
    const { i18n, restaurantAttendance } = this.props

    return (
      <div style={styles.container}>
        <div style={styles.containerData}>
          <div style={styles.header}>
            {i18n.t("occupancy.restaurant.title")}
          </div>
          {restaurantAttendance && (
            <div style={styles.boxData}>
              <div style={styles.boxDataNumber}>
                <p
                  style={{
                    fontSize: "3vmin",
                    color: restaurantAttendance.color,
                    margin: 0
                  }}
                >
                  {restaurantAttendance.time <= 2
                    ? i18n.t("occupancy.restaurant.attendance1")
                    : restaurantAttendance.time <= 4
                    ? i18n.t("occupancy.restaurant.attendance2")
                    : i18n.t("occupancy.restaurant.attendance3")}
                </p>
              </div>
            </div>
          )}
        </div>
        {restaurantAttendance && (
          <div style={styles.colorBar}>
            <div
              style={{ flex: 1, backgroundColor: restaurantAttendance.color }}
            />
          </div>
        )}
      </div>
    )
  }
}

const RestaurantInfoConnected = connect(s => ({
  i18n: s.i18n,
  restaurantAttendance: s.plans.restaurantAttendance,
  status: s.plans.status
}))(RestaurantInfo)
export default RestaurantInfoConnected

const styles = {
  container: {
    flexDirection: "column",
    padding: 10,
    display: "flex",
    flex: 1
  },
  containerData: {
    backgroundColor: config.theme.colors.occupancyBackgroundContent,
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    display: "flex"
  },
  header: {
    color: config.theme.colors.white,
    fontSize: 40,
    marginTop: 10,
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "sans-serif",
    fontWeight: "bold",
    textShadow: "0px 0px 8px #d90f0f"
  },
  boxData: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    position: "relative",
    flexDirection: "column"
  },
  boxDataNumber: {
    margin: "10px",
    flex: 1,
    display: "flex",
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center"
  },
  colorBar: {
    flexDirection: "row",
    height: 5,
    display: "flex"
  }
}



// WEBPACK FOOTER //
// ./src/ui/screens/occupancy/RestaurantInfo.js